import React, { useState, useCallback } from "react";
import { Share2, Check } from "lucide-react";
import { COLORS } from "../constants";
import { pill, fontSerif } from "./styles";
import { buildShareUrl } from "../urlState";

export default function ShareButton({ getPose, timeMode, inline = false }) {
  const [copied, setCopied] = useState(false);
  const [error, setError] = useState(false);

  const handleShare = useCallback(async () => {
    const pose = getPose && getPose();
    const url = buildShareUrl({
      cam: pose && pose.cam,
      target: pose && pose.target,
      timeMode,
    });
    try {
      if (navigator.clipboard && window.isSecureContext !== false) {
        await navigator.clipboard.writeText(url);
      } else {
        // Fallback: legacy execCommand on a hidden textarea
        const ta = document.createElement("textarea");
        ta.value = url;
        ta.style.position = "fixed";
        ta.style.opacity = "0";
        document.body.appendChild(ta);
        ta.select();
        document.execCommand("copy");
        document.body.removeChild(ta);
      }
      // Reflect into the address bar so subsequent shares are deterministic.
      try {
        window.history.replaceState(null, "", url);
      } catch (e) {
        /* ignore */
      }
      setCopied(true);
      setError(false);
      setTimeout(() => setCopied(false), 2200);
    } catch (e) {
      setError(true);
      setTimeout(() => setError(false), 2200);
    }
  }, [getPose, timeMode]);

  return (
    <div
      data-testid="zone-share-wrapper"
      style={
        inline
          ? {
              display: "flex",
              alignItems: "center",
              gap: 10,
              pointerEvents: "auto",
            }
          : {
              position: "absolute",
              top: 164,
              right: 24,
              display: "flex",
              alignItems: "center",
              gap: 10,
              pointerEvents: "auto",
            }
      }
    >
      {(copied || error) && (
        <div
          data-testid={copied ? "zone-share-toast-copied" : "zone-share-toast-error"}
          style={{
            ...pill,
            padding: "6px 12px",
            color: copied ? COLORS.gold : "#ffb4a0",
            fontFamily: fontSerif,
            fontSize: 11,
            letterSpacing: 2,
            textTransform: "uppercase",
            display: "flex",
            alignItems: "center",
            gap: 6,
          }}
        >
          {copied ? <Check size={12} /> : null}
          {copied ? "Link copied" : "Copy failed"}
        </div>
      )}
      <button
        data-testid="zone-share-button"
        onClick={handleShare}
        style={{
          ...pill,
          padding: "8px 14px",
          color: COLORS.ivory,
          fontFamily: fontSerif,
          fontSize: 12,
          letterSpacing: 2,
          textTransform: "uppercase",
          fontWeight: 600,
          cursor: "pointer",
          display: "flex",
          alignItems: "center",
          gap: 8,
        }}
      >
        <Share2 size={14} color={COLORS.gold} />
        Share view
      </button>
    </div>
  );
}
